<template>
  <v-row>
    <div>
      <QuotationBackButton
        v-if="form.cancelada_em == null"
        @back="previousPage"
      />
      <v-spacer />
    </div>
    <BaseTab>
      <v-tab>Histórico de Ações</v-tab>
      <v-tab-item class="pt-8">
        <!-- v-if="hasCurrentHistoricalActions" -->
        <v-row class="py-5 px-4 mb-5">
          <v-col
            cols="12"
            sm="5"
            class="justify-center d-flex justify-sm-start pl-sm-4"
          >
            <p class="primary--text font-weight-bold body-1 mb-sm-0">
              Criada por
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{ form.criada_por.nome }}
              <v-tooltip bottom content-class="tooltip-historical">
                <template v-slot:activator="{ on }">
                  <v-icon color="secondary" size="10" v-on="on" class="pl-1">
                    fa-info-circle
                  </v-icon>
                </template>
                <v-row>
                  <v-col cols="12" class="px-4 py-3">
                    <p
                      class="white--text tooltip-label-text mb-0"
                      style="white-space: pre-line"
                    >
                      Email:
                      {{ form.criada_por.email }}
                      Telefone:
                      {{ form.criada_por.telefone }}
                    </p>
                  </v-col>
                </v-row>
              </v-tooltip>
            </p>
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{ formatIsoDateToDDMMYYYYHHMM(form.criada_em) }}
            </p>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row class="py-5 px-4 mb-5" v-if="Approved">
          <v-col
            cols="12"
            sm="5"
            class="justify-center d-flex justify-sm-start pl-sm-4"
          >
            <p class="primary--text font-weight-bold body-1 mb-sm-0">
              Aprovada por
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{ form.aprovada_por.nome }}
              <v-tooltip bottom content-class="tooltip-historical">
                <template v-slot:activator="{ on }">
                  <v-icon color="secondary" size="10" v-on="on" class="pl-1">
                    fa-info-circle
                  </v-icon>
                </template>
                <v-row>
                  <v-col cols="12" class="px-4 py-3">
                    <p
                      class="white--text tooltip-label-text mb-0"
                      style="white-space: pre-line"
                    >
                      Email:
                      {{ form.aprovada_por.email }}
                      Telefone:
                      {{ form.aprovada_por.telefone }}
                    </p>
                  </v-col>
                </v-row>
              </v-tooltip>
            </p>
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{ formatIsoDateToDDMMYYYYHHMM(form.aprovada_em) }}
            </p>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row class="py-5 px-4 mb-5" v-if="Canceled">
          <v-col
            cols="12"
            sm="5"
            class="justify-center d-flex justify-sm-start pl-sm-4"
          >
            <p class="primary--text font-weight-bold body-1 mb-sm-0">
              Cancelada por
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{ form.cancelada_por.nome }}
              <v-tooltip bottom content-class="tooltip-historical">
                <template v-slot:activator="{ on }">
                  <v-icon color="secondary" size="10" v-on="on" class="pl-1">
                    fa-info-circle
                  </v-icon>
                </template>
                <v-row>
                  <v-col cols="12" class="px-4 py-3">
                    <p
                      class="white--text tooltip-label-text mb-0"
                      style="white-space: pre-line"
                    >
                      Email:
                      {{ form.cancelada_por.email }}
                      Telefone:
                      {{ form.cancelada_por.telefone }}
                    </p>
                  </v-col>
                </v-row>
              </v-tooltip>
            </p>
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <p class="gray--text body-2 mb-sm-0">
              {{ formatIsoDateToDDMMYYYYHHMM(form.cancelada_em) }}
            </p>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row class="justify-center align-center text-center" v-if="isLoading">
          <v-col cols="12">
            <v-progress-circular indeterminate color="primary" />
            <p class="mt-4">
              Verificando se houve alteração na cotação, por favor, aguarde...
            </p>
          </v-col>
        </v-row>
        <v-row class="py-5 px-4 mb-5" v-if="!isLoading && differences.length">
          <v-col
            cols="12"
            sm="auto"
            class="justify-center d-flex justify-sm-start"
          >
            <div>
              <h3>Alterações na cotação:</h3>
              <ul>
                <li v-for="(group, index) in differences" :key="index">
                  <p class="mt-8">
                    <strong>Modificada por:</strong> {{ group.modificadoPor }}
                  </p>
                  <p>
                    <strong>Modificada em:</strong>
                    {{ formatIsoDateToDDMMYYYYHHMM(group.modificadoEm) }}
                  </p>
                  <ul>
                      <p><strong>Payload:</strong> {{ group.properties }}</p>
                  </ul>
                </li>
              </ul>
            </div>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row
          class="justify-center align-center text-center"
          v-if="!isLoading && !differences.length"
        >
          <v-col cols="12">
            <p>Nenhuma alteração foi encontrada na cotação.</p>
          </v-col>
        </v-row>
      </v-tab-item>
    </BaseTab>
  </v-row>
</template>

<script>
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { formatIsoDateToDDMMYYYYHHMM } from "@/utils/formats.js";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import { mapActions } from "vuex";

export default {
  data: () => ({
    formatIsoDateToDDMMYYYYHHMM,
    quotation: {},
    modificadoEm: null,
    modificadoPor: null,
    isLoading: false,
    filteredProperties: [
      "MODALIDADE NOME",
      "SUBMODALIDADE NOME",
      "AREA RISCO CEP",
      "AREA RISCO CIDADE",
      "AREA RISCO UF NOME",
      "SEGURADO NUMERO DOCUMENTO",
      "SEGURADO NOME",
      "SEGURADO CELULAR",
      "SEGURADO EMAIL"
    ],
    differences: []
  }),
  components: {
    QuotationBackButton
  },
  mixins: [LoadingRequest],
  created() {
    this.requestCurrentQuotationAgro(this.$route.params?.id).then(() => {
      this.fetchJsonQuotation();
    });
  },
  computed: {
    Approved() {
      return this.form.aprovada_por != null;
    },
    Canceled() {
      return this.form.cancelada_por != null;
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestJsonQuotationAgro",
      "requestCurrentQuotationAgro"
    ]),

    previousPage() {
      this.$emit("return");
    },
    cleanPropertyName(propertyName) {
      return propertyName
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/^[a-z]/, match => match.toUpperCase());
    },
    fetchJsonQuotation() {
      this.isLoading = true;
      const id = this.$route.params?.id;
      if (id != null) {
        this.withLoading(this.requestJsonQuotationAgro(id))
          .then(data => {
            if (data.length == 0) {
              this.isLoading = false;
            }
            if (typeof data == "object" && data.payload != null) {
              try {
                const converter = JSON.parse(data.payload);
                this.quotation = converter;
                this.modificadoEm = data.modificado_em;
                this.modificadoPor = data.modificado_por.nome;
                this.compareObjects();
              } catch (error) {
                console.error("Erro ao processar o payload do objeto:", error);
              }
            } else if (Array.isArray(data)) {
              for (let i = 0; i < data.length; i++) {
                if (data[i].payload != null) {
                  try {
                    const converter = JSON.parse(data[i].payload);

                    if (!Array.isArray(this.quotation)) {
                      this.quotation = [];
                    }

                    this.quotation.push(converter);
                    this.modificadoEm = data[i].modificado_em;
                    this.modificadoPor = data[i].modificado_por.nome;

                    let payloadTratado = JSON.parse(data[i].payload);
                    console.log("payload", payloadTratado);
                    payloadTratado.criadaPor = {
                      id: payloadTratado.criadaPor.id,
                      nome: payloadTratado.criadaPor.nome
                    };
                    payloadTratado.aprovadaPor = {
                      id: payloadTratado.aprovadaPor?.id,
                      nome: payloadTratado.aprovadaPor?.nome
                    };
                    payloadTratado.canceladaPor = {
                      id: payloadTratado.canceladaPor?.id,
                      nome: payloadTratado.canceladaPor?.nome
                    };
                    payloadTratado.custosCafezal = payloadTratado.custosCafezal.find(x => x.aprovadaEm != null) ?? [];
                    payloadTratado.custos = payloadTratado.custos.find(x => x.aprovadaEm != null) ?? [];
                    delete payloadTratado.segurado.usuario;
                    delete payloadTratado.segurado.dadosBancarios;
                    delete payloadTratado.grupoEconomico;

                    this.differences.push({
                      modificadoEm: data[i].modificado_em,
                      modificadoPor: data[i].modificado_por.nome,
                      properties: payloadTratado
                    });

                    /* Devido ao tamanho da complexidade ficou decidido entregar uma versao simplificada e depois retomar o desenvolvimento                    
                    let dataAtual = null;
                    if (data[i + 1] == null) {
                      dataAtual = this.form.custos_cafezal.find(x => x.aprovada_em != null) ?? this.form;
                    } else {
                      dataAtual = JSON.parse(data[i+1].payload).custosCafezal.find(x => x.aprovadaEm != null) ?? JSON.parse(data[i+1].payload);
                    }
                    let dataAnterior = JSON.parse(data[i].payload).custosCafezal.find(x => x.id == dataAtual.id) ?? JSON.parse(data[i].payload);

                    this.compareObjects(dataAnterior, dataAtual);
                    */
                  } catch (error) {
                    console.error(`Erro ao processar o payload ${i + 1}:`, error);
                  }
                } else {
                  console.error("Payload não encontrado no item:", data[i]);
                }
                this.isLoading = false;
              }
            } else {
              console.error("Estrutura de resposta inválida.");
            }
          })
          .catch(error => {
            console.error("Erro ao buscar dados:", error);
          });
      }
    },
    // Função para transformar e achatar objetos
    flattenAndTransformObject(obj, prefix = "") {
      let result = {};

      if (Array.isArray(obj)) {
        // Se for um array, achate cada item individualmente
        obj.forEach((item, index) => {
          Object.assign(
            result,
            this.flattenAndTransformObject(item, `${prefix}[${index}]`)
          );
        });
      } else if (typeof obj == "object" && obj != null) {
        // Se for um objeto, aplique recursão para seus atributos
        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            const newKey = prefix ? `${prefix}.${key}` : key;

            // Recursão para objetos internos
            Object.assign(
              result,
              this.flattenAndTransformObject(value, newKey)
            );
          }
        }
      } else {
        // Se for um valor primitivo, simplesmente adicione ao resultado
        result[prefix] = obj;
      }

      return result;
    },
    transformKeys(flattenedObj) {
      return Object.keys(flattenedObj).reduce((acc, key) => {
        const transformedKey = key
          .replace(/^\[\d+\]\./, "")
          .replace(/\./g, " ")
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .replace(/_/g, " ")
          .replace(/(name|Name|Nome)$/i, "nome")
          .toUpperCase();

        acc[transformedKey] = flattenedObj[key];
        return acc;
      }, {});
    },
    compareObjects(logAtual, logPosterior) {
      const transformObject = obj =>
        (obj && this.flattenAndTransformObject(obj)) || {};
      let transformForm = {
        ...(logPosterior && transformObject(logPosterior)),
        ...(logPosterior?.itens_agricola &&
          Array.isArray(logPosterior.itens_agricola) &&
          logPosterior.itens_agricola.map(item => transformObject(item))),
        ...(logPosterior?.itens_Cafezal &&
          Array.isArray(logPosterior.itens_Cafezal) &&
          logPosterior.itens_Cafezal.map(item => transformObject(item))),
        ...(logPosterior?.custos &&
          Array.isArray(logPosterior.custos) &&
          logPosterior.custos.map(item => transformObject(item))),
        ...(logPosterior?.custos_cafezal &&
          Array.isArray(logPosterior.custos_cafezal) &&
          logPosterior.custos_cafezal.map(item => transformObject(item)))
      };

      this.quotation = logAtual;
      let transformQuotation = {
        ...(this.quotation && transformObject(this.quotation)),
        ...(this.quotation?.itensAgricola &&
          Array.isArray(this.quotation.itensAgricola) &&
          this.quotation.itensAgricola.map(item => transformObject(item))),
        ...(this.quotation?.itensCafezal &&
          Array.isArray(this.quotation.itensCafezal) &&
          this.quotation.itensCafezal.map(item => transformObject(item))),
        ...(this.quotation?.custos &&
          Array.isArray(this.quotation.custos) &&
          this.quotation.custos.map(item => transformObject(item))),
        ...(this.quotation?.custosCafezal &&
          Array.isArray(this.quotation.custosCafezal) &&
          this.quotation.custosCafezal.map(item => transformObject(item)))
      };

      const transformedForm = this.transformKeys(transformForm);
      const transformedQuotation = this.transformKeys(transformQuotation);

      // Combina as propriedades
      const combinedProperties = [
        ...this.filteredProperties,
        ...Object.keys(transformedForm),
        ...Object.keys(transformedQuotation)
      ];

      // Filtra apenas as propriedades que atendem a um dos critérios
      const propertiesToCompare = combinedProperties.filter(
        prop =>
          //(this.filteredProperties.includes(prop) || 
          //prop.includes("[")) &&
          !prop.endsWith("ID") &&
          !prop.includes("ID") &&
          !prop.includes("APROVADA")
      );

      const normalizeDate = date => {
        if (typeof date == "string" && /T\d/.test(date)) {
          return date.split("T")[0];
        }
        return date;
      };

      propertiesToCompare.forEach(prop => {
        let formValue = normalizeDate(transformedForm[prop]);
        let quotationValue = normalizeDate(transformedQuotation[prop]);

        if (typeof formValue == "string") {
          formValue = formValue.toUpperCase();
        }
        if (typeof quotationValue == "string") {
          quotationValue = quotationValue.toUpperCase();
        }

        if (
          formValue != null &&
          quotationValue != null &&
          formValue !== quotationValue
        ) {
          if (
            typeof quotationValue == "number" &&
            typeof formValue == "number"
          ) {
            quotationValue = quotationValue.toFixed(2);
            formValue = formValue.toFixed(2);
          }
          // Verificar se a propriedade já existe em qualquer entrada de differences
          const existingProperty = this.differences.some(diff =>
            diff.properties.some(
              p =>
                p.property === prop &&
                p.formValue === formValue &&
                p.quotationValue === quotationValue
            )
          );

          if (!existingProperty) {
            // Encontrar uma entrada existente com o mesmo modificadoEm e modificadoPor
            const existingEntry = this.differences.find(
              diff =>
                diff.modificadoPor === this.modificadoPor &&
                diff.modificadoEm === this.modificadoEm
            );

            if (typeof formValue == "string" && !formValue?.includes("{") &&
              typeof quotationValue == "string" && !quotationValue?.includes("{")) {
              if (!existingEntry) {
                // Se não existir uma entrada com o mesmo modificadoEm e modificadoPor, cria uma nova
                this.differences.push({
                  modificadoEm: this.modificadoEm,
                  modificadoPor: this.modificadoPor,
                  properties: [
                    {
                      property: prop,
                      formValue,
                      quotationValue
                    }
                  ]
                });
              } else {
                // Se não encontrar a propriedade, adiciona à lista de propriedades dessa entrada
                existingEntry.properties.push({
                  property: prop,
                  formValue,
                  quotationValue
                });
              }
            }
          }
        }
      });
      this.isLoading = false;
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
